import apiClient from '@/lib/apiClient';
import { parseApiError } from '@/lib/apiError';
import type { AuthCredentials } from './types';

export async function authenticateAD(credentials: AuthCredentials): Promise<string> {
  try {
    const { data } = await apiClient.post<{ token: string }>('/auth/login', {
      login: credentials.login,
      password: credentials.password,
    });
    return data.token;
  } catch (err) {
    throw Object.assign(new Error(parseApiError(err, 'Ошибка авторизации')), { cause: err });
  }
}
